"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VaultService = void 0;
const service_1 = require("./service");
const incorrect_encryption_key_1 = require("../../errors/incorrect-encryption-key");
const not_found_1 = require("../../errors/not-found");
const types_1 = require("../../types");
const constants_1 = require("../../constants");
class VaultService extends service_1.Service {
    constructor(wallet, api, service) {
        super(wallet, api, service);
        this.objectType = constants_1.objectType.VAULT;
    }
    setVaultContext(vaultId) {
        const _super = Object.create(null, {
            setVaultContext: { get: () => super.setVaultContext }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.setVaultContext.call(this, vaultId);
            this.setObjectId(vaultId);
            this.setObject(this.vault);
        });
    }
    processVault(object, shouldDecrypt, keys) {
        return __awaiter(this, void 0, void 0, function* () {
            const vault = new types_1.Vault(object, keys);
            if (shouldDecrypt && !vault.public) {
                try {
                    yield vault.decrypt();
                }
                catch (error) {
                    throw new incorrect_encryption_key_1.IncorrectEncryptionKey(error);
                }
            }
            return vault;
        });
    }
    getTagIndex(tags, tag) {
        const index = tags.indexOf(tag);
        if (index === -1) {
            throw new not_found_1.NotFound("Could not find tag: " + tag + " for given vault.");
        }
        return index;
    }
}
exports.VaultService = VaultService;
